import ConfirmAccount from './ConfirmAccount';
export default ConfirmAccount;
